/* istanbul ignore file */
export const getTimeSinceStartup = (): number => Date.now()
